// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import getColor from "@insite/mobius/utilities/getColor";
import { getImageCss, productImageCarouselStyles } from "@west/Overrides/Components/ProductImageCarousel";
import PlayCircle from "@west/XDL/Icons/PlayCircle";
import { css } from "styled-components";

productImageCarouselStyles.prevArrowButton = {
    variant: "secondary",
    color: "text.main",
    css: css`
        border: 0;
        padding: 0;
        background: #fff !important;
        opacity: 1;
        svg {
            color: ${getColor("text.main")};
        }

        &:disabled {
            opacity: 1;
            svg {
                color: ${getColor("common.border")};
            }
        }
    `,
};
productImageCarouselStyles.nextArrowButton = {
    variant: "secondary",
    color: "text.main",
    css: css`
        border: 0;
        padding: 0;
        background: #fff !important;

        svg {
            color: ${getColor("text.main")};
        }
        &:disabled {
            opacity: 1;
            svg {
                color: ${getColor("common.border")};
            }
        }
    `,
};
productImageCarouselStyles.image = {
    css: getImageCss("common.white"),
};

productImageCarouselStyles.videoContainer = {
    css: css`
        position: relative;
        display: flex;
        align-items: center;
        width: 100%;
        height: 100%;
    `,
};

productImageCarouselStyles.playButtonIcon = {
    color: "common.ui1",
    size: 20,
    src: PlayCircle,
    css: css`
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate3d(-50%, -50%, 0);
        height: 100%;
    `,
};
